// Formatação de valores para o cardápio.

// Formata um preço em BRL. Usa Intl quando disponível (todos os navegadores-alvo
// modernos têm), com fallback determinístico "R$ 0,00" para ambientes sem Intl.
const brl =
  typeof Intl !== 'undefined' && typeof Intl.NumberFormat === 'function'
    ? new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' })
    : null;

export function formatBRL(value: number): string {
  const n = Number.isFinite(value) ? value : 0;
  if (brl) return brl.format(n);
  const fixed = n.toFixed(2).replace('.', ',');
  return 'R$ ' + fixed;
}

// Normaliza texto para busca acento-insensível e caixa-insensível.
// "Pão" -> "pao", casando com "pao" / "PÃO" / "pão".
// \p{Diacritic} = marcas diacríticas combinantes (removidas após NFD).
export function normalizeText(value: string): string {
  return String(value ?? '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '')
    .trim();
}
